<template>

  <popover-box ref="popover" :parent="parent" :direction="direction">
    <stepper-range :attribute="attribute" @select="selectAttribute"></stepper-range>
  </popover-box>

</template>

<script>
import StepperRange from './StepperRange.vue'
import PopoverBox from './PopoverBox'
import popoverContainerMixin from './popoverContainerMixin'
import { cloneDeep } from 'lodash'

export default {
  mixins: [
    popoverContainerMixin
  ],
  components: {
    PopoverBox,
    StepperRange
  },
  props: {
    attribute: Object
  },
  methods: {
    selectAttribute (value) {
      let chosenAttribute = cloneDeep(this.attribute)
      chosenAttribute.value = value
      this.$refs.popover.dismiss()
      this.$emit('select', chosenAttribute)
    }
  }
}

</script>



// WEBPACK FOOTER //
// StepperPopover.vue?5449e940